/*eslint-disable*/
import _ from 'lodash'
import ConversationApi from '../../api/communication/conversation'
import TicketApi from '../../api/communication/ticket'

export default [
    {
        path: '',
        name: 'dashboard',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/dashboard/Main.vue'),
        meta: {
            title: 'router.router_dashboard'
        }
    },

    {
        path: 'school',
        name: 'school:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_schools',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: 'school',
                page: $route.query.page
            }
        }
    },

    {
        path: 'course',
        name: 'course:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_courses',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: 'course',
                page: $route.query.page
            }
        }
    },

    {
        path: 'grade',
        name: 'grade:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_grades',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: 'grade',
                page: $route.query.page
            }
        }
    },


    {
        path: 'education-materials',
        name: 'education-materials:main',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/oldEducationMaterials/Main.vue'),
        meta: {
            title: 'router.router_educationMaterials',
            prev: {
                name: 'dashboard'
            }
        },
    },

    {
        path: 'trainer',
        name: 'trainer:main',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/trainer/Main.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
            prev: {
                name: 'dashboard'
            }
        },
    },

     {
        path: 'homework',
        name: 'homework:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_homeworks',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'homework',
                page: $route.query.page,
                isSuccessfullyUpdated: $route.params.isSuccessfullyUpdated,
                isSuccessfullyCreated: $route.params.isSuccessfullyCreated,
            }
        }
    },

    {
        path: 'homework-template',
        name: 'homework-template:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_homeworkTemplates',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'homework-template',
                page: $route.query.page,
                isSuccessfullyUpdated: $route.params.isSuccessfullyUpdated,
                isSuccessfullyCreated: $route.params.isSuccessfullyCreated,
            }
        }
    },

    {
        path: 'lesson-conducting-template',
        name: 'lesson-conducting-template:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_homeworkTemplates',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'lesson-conducting-template',
                page: $route.query.page,
                isSuccessfullyUpdated: $route.params.isSuccessfullyUpdated,
                isSuccessfullyCreated: $route.params.isSuccessfullyCreated,
            }
        }
    },


    {
        path: 'progress/:type',
        name: 'progress',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_progress',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: 'progress-' + $route.params.type,
                page: $route.query.page,
                withoutCreate: true,
                startParameters: {
                    sourceType: $route.params.type === 'olympiad' ?
                        'olympiadLevelStage' : $route.params.type === 'battle' ? 'battleLevelStage' : $route.params.type
                }
            }
        }
    },
    {
        path: 'points-history/:type',
        name: 'points-history',
        component: env.points
            ? () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue')
            : () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/errors/404.vue'),
        meta: {
            title: env.points ? 'router.router_pointsHistory' : 'router.router_notFound',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: 'points-history-' + $route.params.type,
                page: $route.query.page,
                withoutCreate: true,
                startParameters: {
                    sourceType: $route.params.type === 'olympiad' ?
                        'olympiadLevelStage' : $route.params.type === 'battle' ? 'battleLevelStage' : $route.params.type
                }
            }
        }
    },
    {
        path: 'histories-progress/:type',
        name: 'histories-progress',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_historiesProgress',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: $route.params.type !== 'miles' ? $route.params.type + '-points-history' : $route.params.type + '-history',
                page: $route.query.page,
                withoutCreate: true
            }
        }
    },
    {
        path: 'miles-history',
        name: 'miles-history:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_milesHistory',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: 'miles-history',
                page: $route.query.page,
                withoutCreate: true
            }
        }
    },
    {
        path: 'detective-points-history',
        name: 'detective-points-history:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_detective',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: 'detective-points-history',
                page: $route.query.page,
                withoutCreate: true
            }
        }
    },
    {
        path: 'map',
        name: 'map',
        component: env.isMapAvailable
            ? () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/motivation/map/Map.vue')
            : () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/errors/404.vue'),
        meta: {
            title: env.isMapAvailable ? 'router.router_map' : 'router.router_notFound',
            prev: {
                name: 'dashboard'
            }
        },
        props: true
    },
    {
        path: 'detective',
        name: 'detective',
        component: env.isDetectiveAvailable
            ? () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/motivation/detective/Detective.vue')
            : () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/errors/404.vue'),
        meta: {
            title:  env.isDetectiveAvailable ? 'router.router_detective' : 'router.router_notFound',
            prev: {
                name: 'dashboard'
            }
        },
        props: true
    },

    {
        path: 'rating',
        name: 'rating:list',
        component: env.points
            ? () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue')
            : () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/errors/404.vue'),
        meta: {
            title: 'router.router_rating',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: 'rating',
                page: $route.query.page,
                withoutCreate: true
            }
        }
    },

    {
        path: 'battle-rating',
        name: 'battle-rating:list',
        component: env.points
            ? () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/lists/List.vue')
            : () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/errors/404.vue'),
        meta: {
            title: 'router.router_rating',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: 'battle-rating',
                page: $route.query.page,
                withoutCreate: true
            }
        }
    },

    {
        path: 'timetable',
        name: 'timetable',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/timetable/Timetable.vue'),
        meta: {
            title: 'router.router_timetable',
            prev: {
                name: 'dashboard'
            }
        }
    },
    {
        path: 'conversations',
        name: 'conversations',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/communication/messages/Conversations.vue'),
        meta: {
            title: 'router.router_conversations',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                queryPage: $route.query.page,
                unread: $route.params.unread,
                status: $route.params.status
            }
        }
    },

    {
        path: 'conversations/:id',
        name: 'conversation',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/communication/messages/Conversation.vue'),
        meta: {
            title: _.throttle((route) => {
                return ConversationApi.show(route.params.id).then((conversation) => {
                    return conversation.name;
                });
            }, 100, {trailing: false}),
            prev: {
                name: 'conversations'
            }
        },
        props: true
    },
    {
        path: 'messages',
        name: 'messages',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/communication/Messages.vue'),
        meta: {
            title: 'router.router_conversations',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                page: $route.query.page,
                favorite: $route.params.favorite,
                body: $route.params.body
            };
        }
    },
    {
        path: 'support',
        name: 'support',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/communication/support/Support.vue'),
        meta: {
            title: 'router.router_support',
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                queryPage: $route.query.page,
                status: $route.params.status,
                all: $route.params.all
            }
        }
    },
    {
        path: 'support/:id',
        name: 'ticket',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/communication/support/TicketConversation.vue'),
        meta: {
            title: _.throttle((route) => {
                return TicketApi.show(route.params.id).then((ticket) => {
                    return ticket.theme;
                });
            }, 100, { trailing: false }),
            prev: {
                name: 'support'
            }
        },
        props: true
    },
];
